import React, { useRef, useState, useEffect } from "react";
import axios from 'axios';
import Webcam from "react-webcam";
import "./ptmWebcam.css";

import WelcomeSlide from './welcomeSlide';
import Slide4Achievement from './Slide4Achievement';
import Slide3SubTchRoom from './Slide3SubTchRoom';
import TopperSlideComponent from './topperSlide/topperSlideComponent';
import GallerySlideComponent from './gallery/gallerySlideComponent';

const BACKEND_URL = "https://sms.cooledsys.com:5001";
var tokenid = localStorage.getItem('tokenid');
// const API_KEY = "AIzaSyA1WmrIMrUd7uTTwsub_jG7BBI3aBkC9mw";
const API_KEY = "AIzaSyCTgwAfDDKp32P5ZeF-XsPFN3i-BI9Dxbc";


const SlideshowComponent = (props) => {
    const { lstPtmSetting, currentComponentIndex, setCurrentComponentIndex,
        welcomeObj, ptmId,
        sectionId, lstToppers,
        keyTopper, basePathPtmToppers,
        lstSubTchRoom, keySubTchRoom,
        lstAchievement, basePathPtmGallery,
        lstGallery } = props;


    const [queue, setQueue] = useState([]); // Speech queue
    const [isPlaying, setIsPlaying] = useState(false); // Track if speech is playing

    const webcamRef = useRef(null);
    // const [recognizedFaces, setRecognizedFaces] = useState([]);
    // const recognizedSet = useRef(new Set());
    const [flgShowSlide, setFlgShowSlide] = useState('none');
    const [isFullscreen, setIsFullscreen] = useState(false); // Track fullscreen state



    useEffect(() => {
        openFullscreen(document.getElementById('div_slideshow'));
        if (ptmId && sectionId) {
            updatePtmDtlsSvc(ptmId, sectionId);
        }
    }, [ptmId, sectionId]);

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key == 'Escape' && isFullscreen) {
                closeFullscreen();
            }
            if (event.key === 'ArrowRight') {
                goToNextSlide(); // Go to the next slide on right arrow press
            }
            if (event.key === 'ArrowLeft') {
                goToPrevSlide(); // Go to the prev slide on right arrow press
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isFullscreen]);

    const openFullscreen = async (elem) => {
        try {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            }
            await setFlgShowSlide('flex');
            await setIsFullscreen(true);
        } catch (err) {
            console.error('Error entering fullscreen:', err);
        }
    };

    // Method to go to the next slide
    const goToNextSlide = () => {
        setCurrentComponentIndex((prevIndex) => (prevIndex + 1) % lstPtmSetting.length);
    };
    // Method to go to the next slide
    const goToPrevSlide = () => {
        setCurrentComponentIndex(
            (prevIndex) => {
                if (prevIndex != 0) {
                    return (prevIndex - 1) % lstPtmSetting.length;
                } else {
                    return lstPtmSetting.length - 1
                }
            })
    };
    const closeFullscreen = async () => {
        await setFlgShowSlide('none');
        await setIsFullscreen(true);
        await setCurrentComponentIndex(0);

        try {
            if (document.exitFullscreen) {
                document.exitFullscreen().catch(err =>
                    console.error("Error exiting fullscreen:", err)
                );
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen().catch(err =>
                    console.error("Error exiting fullscreen:", err)
                );
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen().catch(err =>
                    console.error("Error exiting fullscreen:", err)
                );
            }
        } catch (err) {
            console.error('Error exiting fullscreen:', err);
        }

        // Stop the webcam properly
        if (webcamRef.current && webcamRef.current.stream) {
            webcamRef.current.stream.getTracks().forEach(track => track.stop());
        }

        // Clear any ongoing speech synthesis
        window.speechSynthesis.cancel();
    };

    useEffect(() => {
        if (!isPlaying && queue.length > 0) {
            playNextSpeech();
        }
    }, [queue, isPlaying]); // Runs when queue or isPlaying changes

    const speakText = async (text, language = "en-IN") => {
        return new Promise(async (resolve) => {
            try {
                const response = await axios.post(
                    `https://texttospeech.googleapis.com/v1/text:synthesize?key=${API_KEY}`,
                    {
                        input: { text },
                        voice: { languageCode: language, name: `${language}-Wavenet-E` },
                        // voice: { languageCode: language, name: `${language}-Standard-C` },
                        audioConfig: {
                            audioEncoding: "MP3",
                            // speakingRate: 1.12
                        },
                    }
                );

                if (response.data.audioContent) {
                    const audio = new Audio(`data:audio/mp3;base64,${response.data.audioContent}`);

                    audio.onended = () => resolve(); // Resolve after speech ends
                    setIsPlaying(true);
                    audio.play();
                } else {
                    resolve();
                }
            } catch (error) {
                console.error("Error:", error.response ? error.response.data : error.message);
                resolve();
            }
        });
    };

    const playNextSpeech = async () => {
        if (queue.length > 0) {
            const { text1, text2, locale } = queue[0]; // Get first item
            setQueue((prevQueue) => prevQueue.slice(1)); // Remove first item from queue

            await speakText(text1, locale);
            await new Promise((resolve) => setTimeout(resolve, 100)); // Wait 2 seconds
            await speakText(text2, locale);

            setIsPlaying(false);
        }
    };

    const enqueueSpeech = (text1, text2, locale) => {
        setQueue((prevQueue) => [...prevQueue, { text1, text2, locale }]);
    };



    const speak = (message1, message2, locale) => {
        // console.log('speak method called ', message1, message2, locale);
        const speech1 = new SpeechSynthesisUtterance(message1);
        const speech2 = new SpeechSynthesisUtterance(message2);
        speech1.lang = locale;
        speech2.lang = locale;
        speech1.rate = 1;
        speech2.rate = 1;
        speech1.pitch = locale === "en-IN" ? 1.8 : 1.0;
        speech2.pitch = locale === "en-IN" ? 1.8 : 1.0;
        window.speechSynthesis.speak(speech1);
        setTimeout(() => {
            window.speechSynthesis.speak(speech2);
            // speakText(message2, locale);
        }, 2000);
    };

    // const updateWelcomed = () => {
    //     // console.log("updateWelcomed called");
    //     try {
    //         const url = new URL(`${BACKEND_URL}/ptm_hdr/save`);
    //         url.searchParams.append('ptmId', parseInt(nptmId));
    //         url.searchParams.append('sectionId', parseInt(nsectionId));

    //         const response = await fetch(url, {
    //             method: "GET",
    //             headers: { "Content-Type": "application/json", "tokenid": tokenid },
    //         });

    //         const data = await response.json();
    //         // console.log("updatePtmDtlsSvc response ", data);
    //         if (data) {

    //         } else {
    //         }
    //     } catch (error) {
    //         console.error("Recognition error:", error);
    //     }
    // }

    const updatePtmDtlsSvc = async (nptmId, nsectionId) => {
        try {
            const url = new URL(`${BACKEND_URL}/ptm_hdr/save`);
            url.searchParams.append('ptmId', parseInt(nptmId));
            url.searchParams.append('sectionId', parseInt(nsectionId));

            const response = await fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json", "tokenid": tokenid },
            });

            const data = await response.json();
            // console.log("updatePtmDtlsSvc response ", data);
            if (data) {

            } else {
            }
        } catch (error) {
            console.error("Recognition error:", error);
        }
    };

    const captureAndRecognize = async () => {
        if (!webcamRef.current) return;
        const imageSrc = webcamRef.current.getScreenshot();
        if (!imageSrc) return;
        const base64Image = imageSrc.split(",")[1];
        try {
            const url = new URL(`${BACKEND_URL}/recognise`);
            // url.searchParams.append('ptmId', parseInt(ptmId));
            // url.searchParams.append('sectionId',parseInt(sectionId));
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json", "tokenid": tokenid },
                body: JSON.stringify({ 'ptmId': parseInt(ptmId), 'sectionId': parseInt(sectionId), image: base64Image }),
                // body: {'ptmId': parseInt(ptmId),'sectionId':parseInt(sectionId),image:JSON.stringify(base64Image )},
            });
            const data = await response.json();
            // console.log("data received in recognize", JSON.stringify(data, null, 2));
            // enqueueSpeech("चंदन, सुप्रभात! आनंदी राहा!", "तुमचा मुलगा अर्णव आमच्या शाळेच्या संघाचा कर्णधार म्हणून निवडला गेला आहे.", "mr-IN");
            if (!data.welcomed) {
                enqueueSpeech(data.greeting, data.accolade, data.greetingLocale || "en-IN");
                // speak(data.greeting, data.accolade, data.greetingLocale || "en-IN");
            }
        } catch (error) {
            console.error("Recognition error:", error);
            // speak("Recognition failed. Please try again.", "", "");
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            captureAndRecognize();
        }, 5000);
        return () => {
            clearInterval(interval);
            // Stop the webcam properly when component unmounts
            if (webcamRef.current && webcamRef.current.stream) {
                webcamRef.current.stream.getTracks().forEach(track => track.stop());
            }
            // Clear any ongoing speech synthesis
            window.speechSynthesis.cancel();
        };
    }, []);

    const getSlideComponent = (index) => {
        switch (index) {
            case 1: return <WelcomeSlide data={welcomeObj} ptmId={ptmId} sectionId={sectionId} />;
            case 2: return <TopperSlideComponent lstTopper={lstToppers} key={keyTopper} flgEditPlay={"play"} basePathPtmToppers={basePathPtmToppers} />;
            case 3: return <Slide3SubTchRoom lstSubTchRoom={lstSubTchRoom} key={keySubTchRoom} ptmId={ptmId} sectionId={sectionId} />;
            case 4: return <Slide4Achievement content={lstAchievement} ptmId={ptmId} sectionId={sectionId} />;
            case 5: return <GallerySlideComponent flgEditPlay="play" basePathPtmGallery={basePathPtmGallery} lstPtmGallery={lstGallery} />
        }
    };


    return (
        <div className="container">
            <div id="div_slideshow"
                style={{
                    position: "relative",
                    // zIndex:1000,
                    width: '100%', height: '100%',
                    background: '#1c1c1c',
                    display: flgShowSlide,
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                {getSlideComponent(lstPtmSetting[currentComponentIndex].slideId)}
                {
                    flgShowSlide === 'flex' && isFullscreen ?
                        <div className="webcam-overlay">
                            <Webcam ref={webcamRef} className="webcam" screenshotFormat="image/jpeg" />
                        </div>
                        : null
                }
            </div>
            {/* <div className="recognized-container">
                <h3>Recognized Parents:</h3>
                {recognizedFaces.length > 0 ? (
                    recognizedFaces.map((face, index) => (
                        <p key={index}>{face.parent} - {face.message}</p>
                    ))
                ) : (
                    <p>No recognized faces yet.</p>
                )}
            </div> */}
        </div>
    );
}

export default SlideshowComponent;